export default __webpack_public_path__ + "static/media/bkg--interiors-1.b1427d0e.jpg";